import React from "react";
import { Tooltip } from "antd";

const Button = ({
  RigthIcon,
  text,
  key,
  onClick,
  icon,
  className,
  style,
  iconClassName,
  isRigthIcon,
  disabled,
  tooltipText,
  htmlType,
  ...rest
}) => {
  const buttonType = htmlType || rest.type;
  return typeof icon === "string" ? (
    <button
      type={buttonType}
      className={`${className} button-wrapper submitting-button`}
      onClick={onClick}
      style={{ ...style }}
      disabled={disabled}
    >
      {icon !== "empty" &&
        (tooltipText ? (
          <Tooltip title={tooltipText}>
            <img src={icon} alt="icon" className={iconClassName} />
          </Tooltip>
        ) : (
          <img src={icon} alt="icon" className={iconClassName} />
        ))}
      <span> {text}</span>
      {isRigthIcon && (
        <div className="rigth-icon-wrapper">
          <img src={RigthIcon} alt="icon" className={iconClassName} />
        </div>
      )}
    </button>
  ) : (
    <button
      type={buttonType}
      style={{ ...style }}
      disabled={disabled}
      onClick={onClick}
      className={`submitting-button ${className}`}
    >
      {text}
    </button>
  );
};

export default Button;
